/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Checkmark = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 12 10" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M4.14 10L.37 6.1a1.36 1.36 0 0 1 0-1.85 1.21 1.21 0 0 1 1.77 0l2 2.08L9.87.38a1.21 1.21 0 0 1 1.77 0 1.35 1.35 0 0 1 0 1.84z" />
      </g>
    </svg>
  </span>
);

Checkmark.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Checkmark.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Checkmark;
